import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useSpoolEmissionPerSecond = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK ? 'spoolEmissionPerSecond' : null,
        () => interfaceSDK!.get.getSpoolEmissionPerSecond(),
        {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        }
    );

    return {
        spoolEmissionPerSecond: data,
        isLoading: !error && !data,
        error,
    };
};

export default useSpoolEmissionPerSecond;
